var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" }, attrs: { span: 12 } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "50px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("改标类型列表：")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.showGbDiaLog }
                    },
                    [_vm._v("添加")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.output }
                    },
                    [_vm._v("导出")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.resData
                ? _c(
                    "div",
                    { staticStyle: { "margin-bottom": "0" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          attrs: {
                            data: _vm.resData.list,
                            "tooltip-effect": "dark"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "id",
                              label: "序号",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "改标类型",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "code",
                              label: "改标类型编码",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "piece_coefficient",
                              label: "计件系数",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "admin_name",
                              label: "更新人",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "update_time",
                              label: "更新时间",
                              width: "160px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function($event) {
                                              return _vm.editGbType(scope.row)
                                            }
                                          }
                                        },
                                        [_vm._v("\n                编辑")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              99092133
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.diaLogTitle,
            visible: _vm.gbTypeFormVisible,
            width: "30%",
            "before-close": _vm.handleGbTypeClose,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.gbTypeFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "110px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "改标类型编码", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "mini",
                      readonly: _vm.readonly,
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.form.code,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "改标类型名称", required: "" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "计件系数", required: "" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.form.piece_coefficient,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "piece_coefficient", $$v)
                      },
                      expression: "form.piece_coefficient"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: { click: _vm.handleGbTypeClose }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.saveGbType }
                },
                [_vm._v("\n        确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bbab91c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbab91c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GaiBiao/GbTypeSetting.vue
// module id = null
// module chunks = 